{
  "nav": {
    "chat": "Oturum",
    "agents": "Vekiller",
    "history": "Geçmiş",
    "files": "Dosyalar",
    "changes": "Değişiklikler",
    "mailbox": "Posta Kutusu",
    "skills": "Beceriler",
    "worktrees": "Çalışma Ağaçları",
    "design": "Tasarım Stüdyosu",
    "officemap": "Ofis Haritası",
    "settings": "Ayarlar",
    "sddwizard": "Yeni SDD Projesi",
    "specs": "Spesifikasyonlar",
    "sddboard": "Canlı Pano",
    "autophase": "Aşamalar",
    "fleet": "Filo",
    "inspector": "Denetçi",
    "prompts": "Promptlar"
  },
  "brand": {
    "returnToChat": "{{name}} — sohbete dön",
    "returnToChatDefault": "WrongStack — sohbete dön"
  },
  "status": {
    "connected": "Bağlı",
    "disconnected": "Bağlı değil",
    "idle": "Boşta",
    "thinking": "Düşünüyor",
    "running": "Çalışıyor",
    "waiting": "Bekliyor",
    "done": "Bitti",
    "stopped": "Durduruldu"
  },
  "menu": {
    "moreWithHidden": "Daha fazla, {{count}} gizli öğe",
    "moreOptions": "Daha fazla seçenek",
    "moreCompactHidden": "Daha fazla — {{count}} gizli panel/görünüm, palet, tema, izleyiciler",
    "moreCompact": "Daha fazla — palet, tema, izleyiciler",
    "moreFull": "Daha fazla — palet, tema, kısayollar, izleyiciler",
    "commandPalette": "Komut Paleti",
    "keyboardShortcuts": "Klavye Kısayolları",
    "panels": "Paneller",
    "views": "Görünümler",
    "theme": "Tema",
    "monitors": "İzleyiciler",
    "fleetMonitor": "Filo İzleyici",
    "agentsMonitor": "Vekil İzleyici"
  },
  "sidePanel": {
    "dragHint": "Yeniden boyutlandırmak için sürükle · sıfırlamak için çift tıkla",
    "collapse": "Paneli daralt (Ctrl+\\)"
  },
  "history": {
    "openDashboard": "Oturum panosunu aç"
  },
  "agents": {
    "pending": "bekliyor…",
    "empty": "Henüz vekil yok",
    "emptyHint": "Filo etkinken alt vekiller burada görünür.",
    "runningCount": "{{count}} çalışıyor",
    "totalCount": "toplam {{count}}",
    "openFull": "Tam vekil görünümünü aç",
    "agentsLive": "ARACILAR · CANLI",
    "doneCount": "{{count}} tamam",
    "failedCount": "{{count}} başarısız",
    "modelsLabel": "modeller",
    "shownLabel": "gösterilen",
    "totalLabel": "toplam",
    "leaderFleetTotals": "(lider {{leader}} · filo {{fleet}})",
    "navHintJk": "gezinmek için j/k veya ↑↓",
    "escCloseDetail": "· detayı kapatmak için Esc",
    "noAgentsRunning": "Çalışan aracı yok.",
    "contextUsage": "Bağlam kullanımı",
    "lastToolLabel": "son:",
    "unknownSession": "Bilinmeyen oturum",
    "sessionCopyTitle": "Oturum: {{sid}} — kimliği kopyalamak için tıklayın",
    "sessionWord": "oturum",
    "agentsCountSuffix_one": "{{count}} aracı",
    "agentsCountSuffix_other": "{{count}} aracı",
    "sessionTitle": "Oturum: {{sid}}",
    "projectSuffix": " · Proje: {{name}}",
    "statusIdle": "boşta"
  },
  "changes": {
    "fileCount_one": "{{count}} dosya",
    "fileCount_other": "{{count}} dosya",
    "refreshTitle": "Değişiklikleri yenile",
    "loading": "Değişiklikler yükleniyor…",
    "clean": "Değişiklik yok — çalışma ağacı temiz.",
    "selectPrompt": "Farkı görüntülemek için değiştirilmiş bir dosya seçin.",
    "unified": "Birleşik",
    "unifiedTitle": "Birleşik diff",
    "edit": "Düzenle",
    "editTitle": "Yan yana düzenlenebilir diff",
    "loadingDiff": "Diff yükleniyor…",
    "binary": "İkili dosya — diff gösterilmiyor.",
    "tooLarge": "Dosya diff için çok büyük."
  },
  "inspector": {
    "showPanel": "Denetçi panelini göster (Filo / Vekiller / Denetim)",
    "hidePanel": "Denetçi panelini gizle",
    "label": "Denetçi",
    "openAudit": "Denetim sekmesini aç",
    "tabFleet": "Filo",
    "tabAgents": "Vekiller",
    "tabAudit": "Denetim",
    "collapseAria": "Denetçi panelini daralt",
    "collapseTitle": "Daralt (Esc)",
    "noAgentsActive": "Etkin vekil yok",
    "agentsAppearHint": "Filo etkinken vekiller burada görünür.",
    "selected": "{{name}} (seçili)"
  },
  "nextSteps": {
    "header": "Sonraki adımlar",
    "autoSubmitting": "otomatik gönderiliyor",
    "clickToFill": "doldurmak için tıkla",
    "clickToFillTitle": "Doldurmak için tıkla: {{text}}",
    "auto": "otomatik",
    "willAutoSubmit": "Geri sayımdan sonra otomatik gönderilecek"
  },
  "mailbox": {
    "onlineCount": "{{count}} çevrimiçi",
    "messages": "Mesajlar",
    "deleteAllTitle": "Tüm mesajları sil",
    "deleteAll": "Tümünü sil",
    "deleting": "Siliniyor…",
    "purgeTitle": "Eski/yetim mesajları temizle",
    "purge": "Temizle",
    "purging": "Temizleniyor…",
    "newLabel": "YENİ",
    "empty": "Henüz mesaj yok.",
    "offlineCount": "+{{count}} çevrimdışı",
    "timeNow": "şimdi",
    "deleteAllConfirmTitle_one": "{{count}} mesaj silinsin mi?",
    "deleteAllConfirmTitle_other": "Tüm {{count}} mesaj silinsin mi?",
    "deleteAllConfirmBody": "Posta kutusu dosyası her vekil için kısaltılır. Bu geri alınamaz.",
    "purgeConfirmTitle": "Eski mesajlar temizlensin mi?",
    "purgeConfirmBody": "1 günden eski tamamlanmış ve 7 günden eski tamamlanmamış mesajları kaldırır. Etkin mesajlar korunur.",
    "type": {
      "note": "Not",
      "ask": "Soru",
      "assign": "Atama",
      "steer": "Yönlendir",
      "btw": "Bu arada",
      "broadcast": "Yayın",
      "status": "Durum",
      "result": "Sonuç"
    },
    "emptyDetail": "Mesaj seçilmedi",
    "emptyDetailHint": "Burada görüntülemek için Posta Kutusu panelinden bir mesaja tıklayın.",
    "readBy": "Okuyanlar",
    "backToChat": "Sohbete dön",
    "completed": "Tamamlandı",
    "everyone": "herkes",
    "closeTitle": "Kapat (Esc)",
    "replyTo": "Yanıt olarak: {{id}}",
    "completedBy": "{{name}} tarafından tamamlandı",
    "completedByAt": "{{name}} tarafından {{time}} tarihinde tamamlandı",
    "outcome": "Sonuç:",
    "task": "Görev:",
    "messageNotFound": "Mesaj bulunamadı",
    "messageNotFoundHint": "Bu mesaj silinmiş veya temizlenmiş olabilir."
  },
  "sessions": {
    "recentSessions": "Son oturumlar",
    "deleteEmptyTitle_one": "{{count}} boş oturum silinsin mi?",
    "deleteEmptyTitle_other": "{{count}} boş oturum silinsin mi?",
    "deleteEmptyConfirmBody": "Hiç token kullanımı olmayan oturumlar diskten kaldırılır.",
    "filterPlaceholder": "Başlık, model, sağlayıcı filtrele…",
    "clearFilter": "Filtreyi temizle",
    "noHistory": "Henüz geçmiş yok",
    "noHistoryHint": "Konuşmalarınız burada görünür",
    "noMatches": "Eşleşme yok",
    "noMatchesHint": "Farklı bir filtre deneyin",
    "group": {
      "favorites": "Favoriler",
      "today": "Bugün",
      "yesterday": "Dün",
      "thisWeek": "Bu hafta",
      "earlier": "Daha önce"
    },
    "nicknamePlaceholder": "Takma ad",
    "empty": "(boş)",
    "resuming": "devam ediliyor…",
    "active": "etkin",
    "renameTitleNickname": "{{nickname}} — özgün: {{title}}",
    "renameTitle": "{{title}}\n\nYeniden adlandırmak için çift tıklayın",
    "unfavorite": "Favoriden çıkar",
    "markFavorite": "Favori olarak işaretle",
    "deleteSessionConfirmTitle": "Oturum silinsin mi?",
    "deleteSessionConfirmBody": "\"{{name}}\" diskten kaldırılacak. Bu geri alınamaz.",
    "deleteSessionTitle": "Oturumu sil"
  },
  "sessionPanel": {
    "actions": {
      "abort": "Durdur",
      "newSession": "Yeni oturum",
      "export": "Dışa aktar",
      "compact": "Sıkıştır",
      "newSessionTitle": "Yeni oturum başlat (Ctrl+N)",
      "exportTitle": "Sohbeti markdown olarak dışa aktar (Ctrl+E)",
      "compactTitle": "Bağlam penceresini sıkıştır",
      "clearTitle": "Bağlamı temizle (Ctrl+L)"
    },
    "model": "Model",
    "modelTitle": "Modeli değiştir (Ctrl+M)",
    "context": "Bağlam",
    "contextTitle": "Bağlam dökümü için tıklayın",
    "sessionLabel": "Oturum",
    "stats": {
      "messages": "Mesajlar",
      "elapsed": "Geçen",
      "tokens": "Token",
      "cost": "Maliyet",
      "iteration": "Yineleme",
      "agents": "Vekiller",
      "tokensSub": "{{in}} giriş / {{out}} çıkış",
      "iterationOf": "/ {{max}}",
      "agentsRunning": "{{count}} çalışıyor"
    },
    "plan": "Plan",
    "planComplete": "%{{pct}} tamamlandı",
    "pinned": "Sabitlenen",
    "quickSettings": "Hızlı ayarlar",
    "autonomy": "Otonomi",
    "autonomyOptions": {
      "off": "Kapalı",
      "suggest": "Öner",
      "auto": "Otomatik",
      "eternal": "Sürekli",
      "eternal-parallel": "Sürekli Paralel"
    },
    "yolo": "YOLO modu",
    "yoloTitle": "Araç onay istemlerini atla",
    "refine": "Promptları iyileştir",
    "refineTitle": "Göndermeden önce promptları yeniden yaz",
    "sound": "Tamamlanınca ses",
    "soundTitle": "Bir çalışma bitince hafif bir çal sesi çıkar",
    "sessionId": "oturum {{id}}"
  },
  "fleet": {
    "status": {
      "running": "çalışıyor",
      "done": "bitti",
      "failed": "başarısız",
      "timeout": "zaman aşımı",
      "stopped": "durduruldu"
    },
    "leader": "lider",
    "providerModel": "Sağlayıcı / Model",
    "elapsed": "Geçen",
    "running": "çalışıyor…",
    "iterations": "Yinelemeler",
    "toolCalls": "Araç çağrıları",
    "cost": "Maliyet",
    "budgetExtensions": "Bütçe Uzatması",
    "activity": "Etkinlik",
    "budgetWarning": "bütçe uyarısı",
    "contextWindow": "Bağlam penceresi",
    "tokensUsed": "{{used}} / {{max}} token",
    "toolRunning": "çalışıyor…",
    "lastTool": "son araç",
    "error": "Hata",
    "finalOutput": "Son çıktı",
    "copyOutput": "Çıktıyı kopyala",
    "liveOutput": "Canlı çıktı",
    "waitingOutput": "Çıktı bekleniyor…",
    "outputHint": "Vekil metin aktardıkça çıktı burada görünür.",
    "toolLog": "Araç günlüğü ({{count}} çağrı)",
    "fail": "başarısız",
    "moreTools": "+{{count}} araç daha",
    "cardRunning": "çalışıyor {{tool}}",
    "cardLastTool": "son: {{tool}}",
    "contextPercent": "Bağlam %{{pct}}",
    "doneCount": "{{count}} bitti",
    "errCount": "{{count}} hata",
    "statusRunning": "çalışıyor",
    "statusDone": "tamamlandı",
    "statusFailed": "başarısız",
    "statusTimeout": "zaman aşımı",
    "statusStopped": "durduruldu",
    "sessionPrefix": "oturum:",
    "currentTask": "Mevcut görev",
    "performance": "Performans",
    "uniqueTools": "Benzersiz araçlar",
    "avgPerTool": "araç başına ortalama {{ms}}ms",
    "context": "Bağlam",
    "tokens": "Tokenler",
    "ctxUsed": "%{{pct}} kullanıldı",
    "completed": "tamamlandı",
    "budgetWarningTitle": "⚡ Bütçe uyarısı",
    "hittingLimit": "{{kind}} sınırına ulaşılıyor ({{used}}/{{limit}})",
    "hittingLimitTitle": "⚡ {{kind}} sınırına ulaşılıyor ({{used}}/{{limit}})",
    "budgetExt_one": "{{count}} bütçe uzantısı",
    "budgetExt_other": "{{count}} bütçe uzantısı",
    "extendedTimes_one": "Aracı uzun süren görevler nedeniyle bütçesini {{count}} kez uzattı",
    "extendedTimes_other": "Aracı uzun süren görevler nedeniyle bütçesini {{count}} kez uzattı",
    "errorLabel": "Hata",
    "failureReason": "Başarısızlık nedeni",
    "failed": "Başarısız",
    "fleetMonitor": "FİLO İZLEYİCİ",
    "runningCount": "{{count}} çalışıyor",
    "totalAgents_one": "toplam {{count}} aracı",
    "totalAgents_other": "toplam {{count}} aracı",
    "noLeader": "lider yok",
    "closeFleet": "Filo izleyiciyi kapat",
    "colName": "Ad",
    "colStatus": "Durum",
    "colActivity": "Etkinlik",
    "colIters": "Yine.",
    "colTools": "Araçlar",
    "colCost": "Maliyet",
    "colCtx": "BĞM",
    "colExt": "Uzat.",
    "colReason": "Neden",
    "noAgentsActive": "Etkin aracı yok",
    "agentsAppear": "Filo etkin olduğunda aracılar burada görünür.",
    "agentTimeline": "Aracı zaman çizelgesi",
    "noAgentEvents": "Henüz aracı konuşma olayı yok.",
    "navHint": "↑↓ gezin",
    "selectDetailHint": "↵ detay seç",
    "escHint": "Esc seçimi kaldır / kapat",
    "detailedView": "detay görünümü",
    "closeBtn": "✕ kapat",
    "selectAgentDetail": "Detaylı bilgi görmek için bir aracı seçin",
    "selectAgentBody": "Detaylı metrikler, araç günlükleri, akan çıktı ve fazlasını görmek için listedeki herhangi bir aracı tıklayın — sohbet geçmişi detay görünümüne benzer.",
    "navigateWord": "gezin",
    "selectWord": "seç",
    "deselectWord": "seçimi kaldır"
  },
  "context": {
    "wsNotConnected": "WebSocket bağlı değil",
    "noData": "Hata ayıklama verisi alınamadı. Sunucu bağlam hata ayıklamayı desteklemiyor olabilir.",
    "title": "Bağlam Dökümü",
    "windowUsage": "Pencere Kullanımı",
    "contextMode": "Bağlam Modu",
    "fetching": "Bağlam dökümü getiriliyor…",
    "systemPrompt": "Sistem Promptu",
    "tools": "Araçlar",
    "messages": "Mesajlar",
    "tokenAllocation": "Token Dağılımı",
    "systemTitle": "Sistem: {{tokens}}",
    "toolsTitle": "Araçlar: {{tokens}}",
    "messagesTitle": "Mesajlar: {{tokens}}",
    "system": "Sistem",
    "toolBreakdown": "Araç Dökümü",
    "messagesSummary": "Mesajlar ({{count}}) — {{total}} tok",
    "barWithTokens": "Bağlam penceresi: {{tokens}} / {{max}} token ({{pct}})",
    "barPct": "Bağlam penceresi: {{pct}}",
    "barClick": " — döküm için tıklayın"
  },
  "refine": {
    "header": "✨ Promptu İyileştir",
    "autoSend": "{{count}} sn içinde otomatik gönder",
    "cancelTitle": "İptal (Esc)",
    "editLabel": "İyileştirilmiş promptu düzenle:",
    "editPlaceholder": "İyileştirilmiş promptu düzenle...",
    "useEdit": "Düzenlemeyi Kullan",
    "original": "Orijinal",
    "refined": "İyileştirilmiş",
    "yourLanguage": "(dilinizde)",
    "refinedTitle": "Bu sürümü kullanmak için tıklayın veya Enter'a basın",
    "english": "İngilizce",
    "englishTitle": "İngilizce sürümü kullanmak için e'ye basın",
    "hintRefined": "iyileştirilmiş",
    "hintEnglish": "İngilizce",
    "hintOriginal": "orijinal",
    "hintEdit": "düzenle",
    "edit": "Düzenle",
    "useRefined": "İyileştirilmişi Kullan"
  },
  "specs": {
    "heading": "Spesifikasyonlar",
    "subtitle": "Spesifikasyon güdümlü geliştirmeyi görüntüle ve yönet",
    "empty": "Spesifikasyon bulunamadı. Oluşturmak için {{command}} kullanın.",
    "tasks": "Görevler ({{count}})",
    "doneCount": "{{count}} tamamlandı",
    "runningCount": "{{count}} çalışıyor",
    "pendingCount": "{{count}} bekliyor",
    "runTitle": "Bu spesifikasyonu canlı bir AutoPhase panosu olarak çalıştır",
    "run": "Çalıştır",
    "list": "Liste",
    "graph": "Graf",
    "loadingTasks": "Görevler yükleniyor…"
  },
  "refresh": {
    "heading": "F5 Dayanıklılık Doğrulayıcı",
    "subtitle": "En son etkin oturumun, transkriptin ve UI durumunun bir sayfa yenilemesinde kaldığını doğrular. Bu görünümü açın, sonra F5'e basın — her yeşil satır yeşil kalmalıdır.",
    "recordProbe": "Sonda kaydet",
    "latestSession": "En son etkin oturum",
    "restoredLocal": "localStorage'tan geri yüklendi",
    "sessionIdExtra": "oturum kimliği: {{id}}",
    "noSessionYet": "henüz oturum başlatılmadı",
    "activePointer": "Etkin oturum işaretçisi",
    "lastVisited": "lastVisitedAt zaman damgası",
    "never": "hiçbir zaman",
    "persistedEnv": "Kalıcı ortam",
    "transcriptRehydrate": "Sohbet transkripti yeniden doldurma",
    "localTranscript": "Yerel transkript kurtarıldı",
    "messagesExtra": "{{count}} mesaj, {{queued}} sıralı",
    "noMessages": "0 mesaj",
    "noBleed": "Oturumlar arası sızıntı yok",
    "bleedExtra": "bağlı={{bound}} vs etkin={{active}}",
    "transcriptBinds": "transkript etkin oturuma bağlanır",
    "uiWorkspace": "UI çalışma alanı",
    "noneValue": "(yok)",
    "payloadSize": "localStorage yükü (4 anahtar): {{count}} karakter",
    "probeLog": "Sonda günlüğü",
    "noProbes": "Henüz sonda yok — yeniden doldurma kontrolü kaydetmek için üstteki \"Sonda kaydet\" düğmesine basın veya bu görünümde F5'e basın.",
    "simulatedF5": "simüle F5: persist rehydrate yeniden çalıştırılıyor"
  },
  "board": {
    "status": {
      "pending": "Bekliyor",
      "in_progress": "Devam Ediyor",
      "review": "İnceleme",
      "failed": "Başarısız",
      "completed": "Bitti",
      "queued": "Sırada",
      "blocked": "Engelli",
      "cancelled": "İptal edildi"
    },
    "newTaskTitle": "Yeni görev",
    "newTaskPlaceholder": "Görev başlığı…",
    "addTask": "Görev ekle",
    "empty": "Henüz aşama yok — panoyu doldurmak için bir AutoPhase çalıştırması başlatın.",
    "summary": "{{phases}} aşama · {{tasks}} görev",
    "phases": "Aşamalar",
    "statusTab": "Durum",
    "dropHere": "Görevleri buraya bırakın",
    "emptySpec": "Bu spec'te henüz görev yok.",
    "depGraphHeading": "Bağımlılık grafiği",
    "worktreePrefix": "worktree: {{branch}}"
  },
  "debug": {
    "trendUp": "Artıyor",
    "trendDown": "Azalıyor",
    "trendStable": "Sabit",
    "heading": "Hata Ayıklama Panosu",
    "subtitle": "WrongStack WebUI için gerçek zamanlı izleme",
    "refreshLabel": "Yenile:",
    "lastUpdated": "Son güncelleme: {{time}}",
    "fetchFailed": "Metrikler alınamadı",
    "fileWatcher": "Dosya İzleyici",
    "watcherStatus": "İzleyici Durumu",
    "running": "Çalışıyor",
    "stopped": "Durduruldu",
    "activeProjects": "Etkin Projeler",
    "projectsWatched": "İzlenen projeler",
    "fileChanges": "Dosya Değişiklikleri",
    "totalDetected": "Toplam tespit edilen",
    "filesProcessed": "İşlenen Dosyalar",
    "afterHash": "Hash süzgecinden sonra",
    "broadcastsSent": "Gönderilen Yayınlar",
    "toClients": "WebUI istemcilerine",
    "debounceResets": "Debounce Sıfırlamaları",
    "rapidWrites": "Ardışık hızlı yazmalar",
    "avgDebounce": "Ort. Debounce Gecikmesi",
    "actualDelay": "Uygulanan gerçek gecikme",
    "totalDelay": "Toplam Gecikme",
    "sumDelays": "Tüm gecikmelerin toplamı",
    "browserPerf": "Tarayıcı Performansı",
    "heapUsed": "Kullanılan Yığın",
    "jsHeap": "JavaScript yığını",
    "heapTotal": "Toplam Yığın",
    "totalHeap": "Toplam yığın boyutu",
    "pageUptime": "Sayfa Çalışma Süresi",
    "sinceLoad": "Sayfa yüklenmesinden beri",
    "rawData": "Ham Veri"
  },
  "providerModels": {
    "using": "Kullanılan",
    "noModelPicked": "(model seçilmedi)",
    "clearAllowlist": "İzin listesini temizle",
    "clearAllowlistAria": "{{provider}} için kayıtlı izin listesini temizle",
    "refresh": "Sunucudan yenile",
    "refreshAria": "{{provider}} için model listesini yenile",
    "probing": "Sorgulanıyor…",
    "use": "Kullan",
    "useModelAria": "{{provider}} için {{model}} modelini kullan",
    "differsHint": "Sorgulanan liste kayıtlı izin listesinden farklı — kalıcı yapmak için {{command}} komutunu yeniden çalıştırın."
  },
  "dock": {
    "expandChip": "{{label}} öğesini genişlet",
    "collapseChip": "{{label}} öğesini daralt",
    "ahead": "{{count}} ileri",
    "behind": "{{count}} geri",
    "linesAdded": "{{count}} satır eklendi",
    "linesDeleted": "{{count}} satır silindi",
    "untrackedFiles": "{{count}} izlenmeyen dosya",
    "customizeTitle": "Dock çiplerini özelleştir",
    "dockChips": "Dock çipleri",
    "noActiveGoal": "Etkin hedef yok",
    "noActiveGoalDetail": "Sohbetten veya hedef komutundan bir hedef başlatın."
  },
  "agentsMonitor": {
    "leaderBadge": "LİDER",
    "iters": "Yineleme",
    "tools": "Araçlar",
    "activityBins": "Etkinlik (12 kutu)",
    "streamingOutput": "Akış çıktısı",
    "recentTools": "Son araçlar",
    "finalOutput": "Son çıktı",
    "heading": "Vekil İzleyici",
    "prevAgent": "Önceki vekil",
    "nextAgent": "Sonraki vekil",
    "closeAria": "Vekil izleyiciyi kapat",
    "hintPage": "←→ sayfa",
    "hintNavigate": "↑↓ listede gezin",
    "hintEsc": "Esc kapat"
  },
  "terminal": {
    "resize": "Terminalleri yeniden boyutlandır",
    "labelSingular": "Terminal",
    "labelPlural": "Terminaller",
    "projectShell": "Proje kabuğu",
    "maxTerminals": "En fazla {{count}} terminal",
    "newTerminal": "Yeni terminal",
    "restart": "Etkin terminali yeniden başlat",
    "closeAll": "Tüm terminalleri kapat",
    "closeDock": "Terminal dock'unu kapat (Ctrl+`)",
    "closeTab": "{{name}} öğesini kapat",
    "processExited": "[işlem {{code}} koduyla çıktı]"
  },
  "sessionWatch": {
    "liveStream": "Canlı akış",
    "events_one": "{{count}} olay",
    "events_other": "{{count}} olay",
    "interruptTitle": "Bu vekili bir sonraki adımında kooperatif biçimde durdur (süreç öldürme değil)",
    "interrupt": "⏸ Böl",
    "interrupting": "…",
    "loading": "Oturum yükleniyor…",
    "done": "✓✓ bitti",
    "read": "✓ okundu",
    "delivered": "⏳ teslim edildi",
    "agent": "Vekil",
    "you": "Sen",
    "working": "{{name}} · çalışıyor",
    "claude": "Claude",
    "priority": "Öncelik",
    "placeholder": "{{label}} → bu oturuma…",
    "send": "Gönder",
    "sendHint": "⌘/Ctrl+Enter ile gönder · vekilin bir sonraki yinelemesinde görülür",
    "msgType": {
      "steerLabel": "🔄 Yönlendir",
      "steerHint": "Görev sırasında davranışı ayarla",
      "askLabel": "❓ Sor",
      "askHint": "Soru — yanıt bekler",
      "assignLabel": "📋 Ata",
      "assignHint": "Üzerinde işlem yapılacak görev",
      "noteLabel": "💬 Not",
      "noteHint": "Bilgi için, acil değil"
    },
    "sentRunning": "Teslim edildi — çalışan vekil bir sonraki adımda görür",
    "sentIdle": "Teslim edildi — hedef boşta; posta kutusunda görünür, bir sonraki çalıştığında okunur",
    "sentFailed": "Başarısız: {{error}}",
    "interruptReason": "Operatör Fleet HQ'dan durdurma istedi",
    "interruptSent": "Kesme gönderildi — vekil bir sonraki adımda durur (öldürme değil)",
    "interruptFailed": "Kesme başarısız: {{error}}"
  },
  "sideEffects": {
    "empty": "Henüz kayıtlı yan etki yok.",
    "emptyHint": "Bash komutları, paket kurulumları ve ağ istekleri burada görünür.",
    "heading": "Yan Etkiler",
    "exportTitle": "Filtrelenmiş yan etkileri CSV olarak dışa aktar",
    "all": "Tümü",
    "colTime": "Zaman",
    "colTool": "Araç",
    "colRisk": "Risk",
    "colDetail": "Detay",
    "colOutcome": "Sonuç"
  },
  "monitor": {
    "elapsedHm": "{{h}} sa {{m}} dk önce",
    "elapsedMs": "{{m}} dk {{s}} sn önce",
    "elapsedS": "{{s}} sn önce",
    "heading": "Filo İzleyici",
    "clientsHeading": "Bağlı İstemciler",
    "terminal": "Terminal",
    "webui": "Web Arayüzü",
    "repl": "REPL",
    "totalConnected": "toplam bağlı",
    "mailQueue": "Posta Kuyruğu",
    "total": "Toplam",
    "open": "Açık",
    "unread": "Okunmamış",
    "agents": "Vekiller",
    "messagesSub": "mesaj",
    "uncompletedSub": "tamamlanmamış",
    "waitingSub": "bekliyor",
    "ofTotal": "/ {{count}} toplam",
    "agentRoster": "Vekil Çizelgesi",
    "liveMailActivity": "Canlı Posta Etkinliği",
    "noActivity": "Son etkinlik yok",
    "mailboxAgents": "Posta Kutusu Vekilleri",
    "noMailboxAgents": "Kayıtlı vekil yok",
    "moreCount": "+{{count}} daha",
    "agentFallback": "vekil",
    "fleetAgents": "Filo Vekilleri",
    "noFleetAgents": "Çalışan filo vekili yok",
    "iter": "yineleme",
    "mailType": {
      "sent": "Gönderildi",
      "delivered": "Teslim edildi",
      "read": "Okundu",
      "completed": "Tamamlandı"
    }
  },
  "sdd": {
    "status": {
      "pending": "bekliyor",
      "queued": "sırada",
      "in_progress": "çalışıyor",
      "blocked": "engellendi",
      "review": "inceleme",
      "failed": "başarısız",
      "completed": "bitti",
      "cancelled": "iptal edildi"
    },
    "activityHeading": "Etkinlik",
    "feedEmpty": "Henüz bir şey yok — aracılar görevleri alıp bitirdikçe olaylar burada görünür.",
    "destroyTitle": "SDD projesi yok edilsin mi?",
    "destroyDesc": "Bu, çalışmayı ve işini siler. Geri alınamaz (isteğe bağlı commit geri alma geçmiş korur).",
    "stopRun": "Çalışmayı durdur",
    "stopRunAgents_one": "Çalışmayı durdur ({{count}} aracı çalışıyor)",
    "stopRunAgents_other": "Çalışmayı durdur ({{count}} aracı çalışıyor)",
    "removeWorktreesAll": "Tüm git worktree'leri + wstack/ap/* dallarını kaldır — birleştirilmemiş iş dahil",
    "removeWorktreesCount_one": "{{count}} git worktree + wstack/ap/* dallarını kaldır — birleştirilmemiş iş dahil",
    "removeWorktreesCount_other": "{{count}} git worktree + wstack/ap/* dallarını kaldır — birleştirilmemiş iş dahil",
    "deleteArtifacts": "Tüm SDD yapılarını sil (spec'ler, görev grafiği, pano, oturum)",
    "revertMerged_one": "Ayrıca {{count}} birleştirilmiş commit'i geri al",
    "revertMerged_other": "Ayrıca {{count}} birleştirilmiş commit'i geri al",
    "revertHint": "Geri alma commit'leri ekler (geçmiş korunur). Çalışma ağacı kirliyse reddedilir.",
    "baseBranchFallback": "taban dal",
    "noteLeaveMerged": "Birleştirilmiş commit'ler taban dalda bırakılır. Onları da geri almak için yukarıdaki kutuyu işaretleyin.",
    "noteAbandon": "Bu çalışmayı gerçekten terk etmek istediğinizden emin olun.",
    "destroying": "Yok ediliyor…",
    "destroyAll": "Her şeyi yok et",
    "kanbanBacklog": "Bekleme",
    "kanbanReady": "Hazır",
    "kanbanRunning": "Çalışıyor",
    "kanbanReview": "İnceleme",
    "kanbanFailed": "Başarısız",
    "kanbanDone": "Tamamlandı",
    "kanbanEmpty": "boş"
  },
  "toolResult": {
    "collapseToLines": "İlk {{count}} satıra daralt",
    "showAllLines": "Tümünü göster: {{total}} satır ({{more}} satır daha)",
    "exitCode": "çıkış kodu:",
    "jsonLines": "JSON · {{count}} satır",
    "collapse": "daralt",
    "expand": "genişlet"
  },
  "design": {
    "heading": "Tasarım Stüdyosu — Galeri",
    "kitsCount": "{{count}} kit",
    "searchPlaceholder": "Kit ara…",
    "stackTitle": "Use + Materialize için yığın",
    "wrote": "{{path}} yazıldı",
    "materializeFailed": "Materialize başarısız: {{error}}",
    "verifyError": "Doğrula: {{error}}",
    "verifyOffPalette": "Doğrula: %{{pct}} palet üzerinde — {{files}} dosyada {{count}} palet dışı",
    "verifyClean": "Doğrula: temiz ✓ ({{files}} dosya palet üzerinde)",
    "writing": "Tema dosyası yazılıyor…",
    "scanning": "Arayüz dosyaları taranıyor…",
    "active": "Etkin",
    "reapply": "Yeniden uygula",
    "use": "Kullan",
    "materializeTitle": "Token'ları bir {{stack}} tema dosyasına yaz",
    "materialize": "Materialize",
    "verifyTitle": "Palet dışı renkler için arayüz dosyalarını tara",
    "verify": "Doğrula",
    "colors": "Renkler"
  },
  "autoPhase": {
    "summary_one": "{{count}} aşama · %{{pct}} tamamlandı",
    "summary_other": "{{count}} aşama · %{{pct}} tamamlandı",
    "switchBoard": "Panoyu değiştir",
    "boardsCount_one": "{{count}} pano…",
    "boardsCount_other": "{{count}} pano…",
    "toggleAutonomousTitle": "Otonom modu aç/kapat",
    "autonomous": "Otonom",
    "manual": "Manuel",
    "resumeTitle": "Çalıştırmayı sürdür",
    "pauseTitle": "Çalıştırmayı duraklat",
    "resume": "Sürdür",
    "pause": "Duraklat",
    "stopTitle": "Çalıştırmayı durdur — devam eden vekilleri hemen iptal eder",
    "stop": "Durdur",
    "newTitle": "Bu panoyu temizle ve yeni bir AutoPhase çalıştırması başlat",
    "newLabel": "Yeni",
    "revertConfirm": "Çalıştırmanın commit'leri geri alınsın mı?",
    "revertTitle": "Bu çalıştırmayı geri al — işlediği commit'leri git-revert yap ve worktree'lerini kaldır",
    "revert": "Geri al",
    "goal": "Hedef",
    "planning": "Aşamalar planlanıyor…",
    "planningBody": "Hedefiniz alındı. WrongStack onu aşamalara ve görevlere bölüyor — plan hazır olduğunda pano burada görünür.",
    "startHeading": "Aşama Planı Başlat",
    "startBody": "Ne inşa etmek istediğinizi açıklayın. WrongStack aşamaları ve görevleri planlar, sonra uygular — çalıştırmayı panoda izleyin ve yönlendirin.",
    "startPlaceholder": "örn. Express ve SQLite ile kullanıcı yönetimi için bir REST API oluştur...",
    "isolateLabel": "Her aşamayı kendi git worktree'sinde izole et",
    "startButton": "AutoPhase Başlat",
    "ctrlHint": "Başlatmak için Ctrl+Enter",
    "isolateOn": "aşamalar izole worktree'lerde çalışır, squash-merge edilir",
    "isolateOff": "aşamalar doğrudan mevcut dalda çalışır",
    "lanes": "Şeritler",
    "graph": "Graf",
    "planningAck": "🚀 **AutoPhase** — anlaşıldı. Hedefiniz için aşamalar planlanıyor…"
  },
  "collab": {
    "noObservers": "Canlı izleyici yok",
    "observerTitle": "Salt okunur izleyici olarak katıl (Aşama 1)",
    "observerRole": "izleyici",
    "annotatorTitle": "Açıklayıcı olarak katıl — araç çağrılarına satır içi not bırak (Aşama 2)",
    "annotatorRole": "açıklayıcı",
    "controllerTitle": "Kontrolör olarak katıl — vekil döngüsünü duraklatabilir (Aşama 3)",
    "controllerRole": "kontrolör",
    "errorPrefix": "Collab: {{error}}",
    "dismiss": "kapat",
    "observers_one": "{{count}} izleyici",
    "observers_other": "{{count}} izleyici",
    "annotationsTitle": "{{count}} açık not — açıklayıcılar bu oturumu inceliyor",
    "notes_one": "{{count}} not",
    "notes_other": "{{count}} not",
    "pausedTitle": "Vekil döngüsü duraklatıldı — bir kontrolör inceliyor",
    "paused": "duraklatıldı",
    "joinedTitle": "Katıldı {{time}}",
    "grantTitle": "Kontrol ver — bu katılımcıyı kontrolöre yükselt",
    "injectTitle": "Bekleyen bir araç çağrısı için sentetik sonuç enjekte et",
    "inject": "Enjekte et",
    "resumeTitle": "Vekil döngüsünü sürdür",
    "resume": "Sürdür",
    "pauseTitle": "Bir sonraki araç çağrısından önce vekili duraklat",
    "pauseAgent": "Vekili duraklat",
    "leaveTitle": "İzleyici oturumundan ayrıl",
    "leave": "Ayrıl",
    "injectToolResult": "Araç sonucu enjekte et",
    "close": "kapat",
    "targetTool": "Hedef tool_use kimliği",
    "targetPlaceholder": "bekleyen bir çağrı seç veya bir tool_use kimliği yaz",
    "toolFallback": "araç",
    "noPendingTools": "Bekleyen araç çağrısı yok — ön sıraya almak için bir tool_use kimliği yazın veya önce vekili duraklatın.",
    "resultContent": "Sonuç içeriği",
    "resultPlaceholder": "Aracı çalıştırmak yerine vekile beslenen sentetik araç sonucu",
    "markError": "hata olarak işaretle",
    "reasonPlaceholder": "neden (denetim günlüğü)",
    "queueInjection": "Enjeksiyonu sıraya al",
    "controllerInjection": "kontrolör enjeksiyonu"
  },
  "connection": {
    "reconnecting": "Arka uca yeniden bağlanılıyor (deneme {{attempt}}) — {{remaining}} sn içinde yeniden denenecek",
    "disconnected": "Arka uçtan bağlantı kesildi",
    "retry": "Şimdi yeniden dene",
    "retryTitle": "Bağlantıyı şimdi yeniden dene",
    "dismissTitle": "Kapat (üst çubuktaki chip durumu hâlâ gösterir)"
  },
  "mode": {
    "modePrefix": "kip:",
    "activeTitle": "Etkin kip",
    "heading": "Kip",
    "defaultName": "Varsayılan",
    "defaultDesc": "Standart vekil davranışı"
  },
  "cost": {
    "clickTitle": "Tur başına maliyet dökümü için tıklayın",
    "heading": "Maliyet dökümü",
    "noPricing": "Geçerli model için fiyatlandırma yok — maliyet değerleri sıfır.",
    "noTurns": "Henüz tamamlanmış tur yok. Tur başına maliyeti burada görmek için bir komut çalıştırın.",
    "topExpensive_one": "En pahalı {{count}} tur",
    "topExpensive_other": "En pahalı {{count}} tur"
  },
  "model": {
    "runDefault": "Çalıştırma varsayılanı",
    "useRunDefault": "Çalıştırma varsayılanını kullan",
    "filterPlaceholder": "Modelleri filtrele…",
    "loading": "Modeller yükleniyor…",
    "noMatch": "Eşleşme yok"
  },
  "modelSwitcher": {
    "filterPlaceholder": "Sağlayıcıları ve modelleri filtrele…",
    "noSavedProviders": "Kayıtlı sağlayıcı yok — önce Ayarlar'da bir anahtar kaydedin.",
    "active": "etkin"
  },
  "work": {
    "todos": "Yapılacaklar",
    "tasks": "Görevler",
    "plan": "Plan"
  },
  "todos": {
    "toggleAria": "Durumu değiştir: {{content}}",
    "removeTitle": "Todo'yu kaldır",
    "removeAria": "\"{{content}}\" kaldır",
    "completedCount_one": "{{count}} tamamlandı",
    "completedCount_other": "{{count}} tamamlandı"
  },
  "task": {
    "start": "Başlat",
    "complete": "Tamamla",
    "retry": "Yeniden dene",
    "assign": "Ata",
    "assignTitle": "Aracı ata",
    "unassigned": "Atanmamış",
    "statusPending": "Bekliyor",
    "statusInProgress": "Devam ediyor",
    "statusBlocked": "Engelli",
    "statusFailed": "Başarısız",
    "statusReview": "İnceleme",
    "statusDone": "Tamamlandı",
    "startTitle": "Başlat",
    "completeTitle": "Tamamla",
    "fail": "Başarısız",
    "failTitle": "Başarısız olarak işaretle",
    "boardCount": "{{total}} görev · {{done}} tamamlandı"
  },
  "toolGroup": {
    "toolCalls_one": "{{count}} araç çağrısı",
    "toolCalls_other": "{{count}} araç çağrısı"
  },
  "fileRef": {
    "removeTitle": "Referansı kaldır",
    "linesCount_one": "{{count}} satır",
    "linesCount_other": "{{count}} satır"
  },
  "plan": {
    "statusOpen": "Açık",
    "statusInProgress": "Devam ediyor",
    "statusDone": "Tamamlandı",
    "startTitle": "Başlat",
    "doneTitle": "Tamamlandı olarak işaretle",
    "reopenTitle": "Yeniden aç",
    "reopen": "Yeniden aç"
  },
  "filePicker": {
    "heading": "@ Dosyalar",
    "noMatch": "\"{{query}}\" ile eşleşen dosya yok",
    "searching": "Proje aranıyor…"
  },
  "toast": {
    "dismiss": "Kapat"
  },
  "search": {
    "placeholder": "Sohbette ara…",
    "prevHit": "Önceki eşleşme",
    "nextHit": "Sonraki eşleşme",
    "close": "Kapat (Esc)"
  },
  "phase": {
    "statusPending": "Bekliyor",
    "statusReady": "Hazır",
    "statusRunning": "Çalışıyor",
    "statusPaused": "Duraklatıldı",
    "statusCompleted": "Tamamlandı",
    "statusFailed": "Başarısız",
    "statusSkipped": "Atlandı",
    "heading": "Aşamalar",
    "autonomousOn": "● Otonom",
    "autonomousOff": "○ Manuel",
    "autonomousOnTitle": "Otonom mod etkin — duraklatmak için tıklayın",
    "autonomousOffTitle": "Manuel mod — otonomu etkinleştirmek için tıklayın",
    "overallProgress": "Genel ilerleme",
    "tasksSuffix": "{{done}}/{{total}} görev",
    "agentsSuffix_one": "{{count}} aracı",
    "agentsSuffix_other": "{{count}} aracı"
  },
  "ctxMode": {
    "triggerTitle": "Bağlam penceresi kipi",
    "ctxPrefix": "ctx:",
    "opsHeading": "Bağlam işlemleri",
    "compactNow": "Şimdi sıkıştır",
    "compactNowDesc": "Eski araç çıktısını ele",
    "compactAggressive": "Agresif sıkıştır",
    "compactAggressiveDesc": "Şimdi maksimum eleme",
    "repairContext": "Bağlamı onar",
    "repairDesc": "Yetim tool-use bloklarını düzelt",
    "debugContext": "Bağlamı hata ayıkla",
    "debugDesc": "Bölüm başına boyut dökümü",
    "windowHeading": "Bağlam penceresi",
    "keepElide": "{{k}} yakınını tut · {{t}}+ tokeni ele",
    "fallbackName": "Dengeli",
    "fallbackDesc": "Varsayılan rolling sıkıştırma"
  },
  "transcript": {
    "kindAssistant": "Asistan",
    "kindThinking": "Düşünme",
    "kindToolCall": "Araç çağrısı",
    "kindToolResult": "Araç sonucu",
    "kindError": "Hata",
    "kindStatus": "Durum",
    "kindSystem": "Sistem",
    "title": "Sohbet geçmişi",
    "copyTitle": "Aracı sohbet geçmişini kopyala",
    "empty": "Bu aracı için henüz sohbet geçmişi yok."
  },
  "autonomy": {
    "heading": "Otonomi modu",
    "titlePrefix": "Otonomi: {{label}}",
    "descOff": "Tam manuel kontrol — vekil girdinizi bekler.",
    "descSuggest": "Vekil sonraki adımları önerir ama onay bekler.",
    "descAuto": "Vekil kısa onay gecikmesinden sonra otomatik ilerler.",
    "descEternal": "Vekil hedef tamamlanana kadar otonom çalışır.",
    "descEternalParallel": "Çok aracılı otonom yürütme — filo modu."
  },
  "queue": {
    "heading": "Mesaj kuyruğu",
    "subtitle": "{{count}} kuyrukta · vekil bitirmeden önce gönderilen mesajlar",
    "btwTitle": "Bu arada — çalışan vekili bölmeyen takip mesajı olarak gönderilir",
    "steerTitle": "Yönlendir — çalışan vekili böler ve bu mesajla yeniden yönlendirir",
    "queueTitle": "Kuyrukta — mevcut vekil çalışması bitene kadar tutulur, sonra sırayla gönderilir",
    "sortNewestTitle": "En yeni önce sıralandı — en eski önce sıralamak için tıklayın",
    "sortOldestTitle": "En eski önce sıralandı — en yeni önce sıralamak için tıklayın",
    "newest": "En yeni",
    "oldest": "En eski",
    "clear": "Temizle",
    "clearTitle": "Tüm kuyruktaki mesajları temizle",
    "closeTitle": "Kapat",
    "emptyTitle": "Kuyruk boş",
    "emptyBody": "Mesaj eklemek için girdinin yanındaki btw / steer / kuyruğa ekle düğmelerini kullanın. Kuyruktaki öğeler mevcut vekil çalışması bitince sırayla gönderilir.",
    "removeTitle": "Kuyruktan kaldır",
    "footer": "Mesajlar, mevcut vekil çalışması bitince varış sırasına göre gönderilir. En yeni önce görmek için sıralama düğmesini kullanın."
  },
  "checkpoint": {
    "heading": "Oturum kontrol noktaları",
    "countSuffix_one": "{{count}} kontrol noktası",
    "countSuffix_other": "{{count}} kontrol noktası",
    "description": "Oturumu herhangi bir kontrol noktasına geri sarın. Mesajlar ve dosya değişiklikleri o noktaya geri döner — LLM oradan hiçbir şey olmamış gibi devam eder.",
    "emptyTitle": "Henüz kontrol noktası yok",
    "emptyBody": "Her mesaj gönderdiğinizde kontrol noktaları otomatik oluşturulur. Birkaç mesaj gönderip geri dönün.",
    "latest": "en son",
    "msgSuffix_one": "{{count}} msg",
    "msgSuffix_other": "{{count}} msg",
    "footerPre": "Geri sarmak için herhangi bir kontrol noktasına tıklayın",
    "footerPost": "kapatmak için"
  },
  "goal": {
    "statusActive": "Etkin",
    "statusPaused": "Duraklatıldı",
    "statusDone": "Tamamlandı",
    "statusFailed": "Başarısız",
    "statusAbandoned": "Terk edildi",
    "heading": "Hedef",
    "refined": "Arıtılmış",
    "progress": "İlerleme",
    "iterations": "yineleme",
    "deliverables": "Teslimatlar",
    "recentActivity": "Son etkinlik"
  },
  "worktree": {
    "cleanTitle_one": "{{count}} yetim worktree temizlensin mi?",
    "cleanTitle_other": "{{count}} yetim worktree temizlensin mi?",
    "cleanMessage": "Önceki çalışmalardan kalan tüm git worktree + wstack/ap dalını zorla kaldırır. İçlerindeki birleştirilmemiş çalışma kaybolur.",
    "cleanConfirm": "Yetimleri temizle",
    "orphanCount_one": "Önceki çalışmalardan {{count}} yetim worktree",
    "orphanCount_other": "Önceki çalışmalardan {{count}} yetim worktree",
    "andMore": "…ve {{count}} daha",
    "cleanButtonTitle": "Tüm yetim worktree + dalları zorla kaldır",
    "removed_one": "✓ {{count}} yetim worktree kaldırıldı.",
    "removed_other": "✓ {{count}} yetim worktree kaldırıldı.",
    "cleanupFailed": "temizlik başarısız",
    "lanesHeading": "Worktree'ler",
    "base": "taban",
    "isolatedCount_one": "{{count}} yalıtılmış",
    "isolatedCount_other": "{{count}} yalıtılmış",
    "statusAllocating": "ayrılıyor",
    "statusActive": "etkin",
    "statusCommitting": "işleniyor",
    "statusMerging": "birleştiriliyor",
    "statusMerged": "birleştirildi",
    "statusConflict": "çakışma",
    "statusFailed": "başarısız",
    "conflictBadge": "ÇAKIŞMA",
    "graphAria": "{{base}} dışında worktree dal grafiği",
    "mergedLabel": "✓ {{base}} ile birleştirildi"
  },
  "process": {
    "heading": "Çalışan süreçler",
    "subtitle": "{{active}} etkin · {{total}} toplam",
    "killAll": "Tümünü sonlandır",
    "emptyTitle": "İzlenen süreç yok",
    "emptyBody": "Vekil bash veya exec araçlarını çalıştırdığında süreçler burada görünür. Etkin süreçler nabız atan LED gösterir.",
    "pidLabel": "PID {{pid}}",
    "protected": "korumalı",
    "protectedTitle": "Korumalı — kill/killAll'dan sağ kalır",
    "killTitle": "PID {{pid}} sonlandır"
  },
  "diff": {
    "tooLarge": "Diff atlandı (dosya satır içi göstermek için çok büyük)."
  },
  "fallback": {
    "placeholder": "Yedek model ekle…",
    "emptyHint": "Birincil model hız sınırladığında veya takıldığında sırayla denenir.",
    "moveUp": "Yukarı taşı",
    "moveDown": "Aşağı taşı",
    "manualPlaceholder": "sağlayıcı/model",
    "addTitle": "Model referansı ekle"
  },
  "liveSessions": {
    "loading": "Oturumler yükleniyor...",
    "apiUnavailable": "Oturum API'si kullanılamıyor:",
    "empty": "Canlı oturum yok. Burada görmek için başka bir wstack örneği açın.",
    "heading": "Canlı oturumlar ({{count}})",
    "autoRefresh": "5 sn'de bir otomatik yenile",
    "pidLabel": "PID {{pid}}",
    "agentMeta": "{{iter}} yineleme · {{tools}} araç · {{ago}}",
    "andMore": "... ve {{count}} daha",
    "noAgents": "Aracı yok"
  },
  "monacoDiff": {
    "applyTitle": "Düzenlenen sürümü diske yaz",
    "applying": "Uygulanıyor…",
    "applied": "Uygulandı",
    "apply": "Uygula"
  },
  "errorBody": {
    "showStack_one": "Yığın izini göster ({{count}} kare)",
    "showStack_other": "Yığın izini göster ({{count}} kare)",
    "hideStack_one": "Yığın izini gizle ({{count}} kare)",
    "hideStack_other": "Yığın izini gizle ({{count}} kare)"
  },
  "officeMap": {
    "liveHeading": "Canlı",
    "clients": "İstemciler",
    "agents": "Aracılar",
    "model": "Model",
    "mode": "Kip",
    "toolCalls": "Araç çağrıları",
    "displayHeading": "Görünüm",
    "statsHud": "İstatistik HUD",
    "legends": "Açıklamalar",
    "minimap": "Mini harita",
    "zoomControls": "Yakınlaştırma kontrolleri",
    "animateWires": "Bağlantıları animasyonla",
    "backgroundHeading": "Arka plan",
    "bgDots": "Noktalar",
    "bgLines": "Çizgiler",
    "bgCross": "Çapraz",
    "bgNone": "Yok"
  },
  "toolInput": {
    "noParams": "(parametre yok)",
    "itemCount_one": "{{count}} öğe",
    "itemCount_other": "{{count}} öğe",
    "keyCount_one": "{{count}} anahtar",
    "keyCount_other": "{{count}} anahtar"
  },
  "message": {
    "roleYou": "Sen",
    "roleTool": "Araç",
    "roleThinking": "Düşünme",
    "roleAssistant": "Asistan",
    "inputLabel": "Girdi",
    "downloadTitle": "Dosya olarak indir",
    "empty": "(boş)",
    "hideDetails": "Detayları gizle",
    "showDetails": "Detayları göster",
    "showDetailsLines_one": "Detayları göster ({{count}} satır)",
    "showDetailsLines_other": "Detayları göster ({{count}} satır)",
    "editHint": "⌘/Ctrl+Enter ile kaydet · Esc ile iptal",
    "saveResend": "Kaydet ve yeniden gönder",
    "thinkingProcess": "Düşünme süreci",
    "thinkingMeta": "yineleme {{iter}} · {{dur}} · {{lines}}",
    "replay": "tekrar",
    "linesSuffix_one": "{{count}} satır",
    "linesSuffix_other": "{{count}} satır",
    "copyLog": "Günlüğü kopyala",
    "showFullLog": "Tüm günlüğü göster",
    "typing": "Yazıyor…",
    "noContent": "İçerik yok",
    "failedToSend": "⚠ Gönderilemedi",
    "autoPaused": "⚠️ _Otomatik ilerleme duraklatıldı — maksimum ardışık otomatik tur sayısına ulaşıldı. Devam etmek için bir şey yazın (otonomi açık kalır)._",
    "rsIterations": "Yineleme: {{n}}",
    "rsTools": "Araç çağrısı: {{n}}",
    "rsElapsed": "Geçen: {{s}}",
    "rsCost": "Maliyet: {{c}}",
    "useInput": "Girdi: {{n}}",
    "useOutput": "Çıktı: {{n}}",
    "useCacheRead": "Önbellek okuma: {{n}}",
    "useCost": "Maliyet: {{c}}",
    "renderedLabel": "Gösterilen",
    "rawLabel": "Ham",
    "showRenderedTitle": "İşaretlenmiş markdown göster",
    "showRawTitle": "Ham markdown kaynağını göster",
    "editTitle": "Bu komutu düzenle ve yeniden gönder",
    "editLabel": "Düzenle",
    "unpinTitle": "Sabitlemeyi kaldır",
    "pinTitle": "Bu yanıtı sabitle",
    "pinnedLabel": "Sabitlendi",
    "pinLabel": "Sabitle",
    "regenerateTitle": "Bu yanıtı yeniden üret",
    "retryLabel": "Yeniden dene"
  },
  "watch": {
    "toolFallback": "araç",
    "toolFailed": "Araç başarısız"
  },
  "shortcuts": {
    "heading": "Klavye kısayolları",
    "footerPre": "İstediğiniz zaman",
    "footerPost": "bu listeyi yeniden açmak için basın.",
    "sectionGlobal": "Genel",
    "sectionTuiParity": "TUI panel eşliği",
    "sectionFleet": "Filo & Aracılar",
    "sectionChatInput": "Sohbet girişi",
    "sectionChat": "Sohbet",
    "sectionChatNav": "Sohbet gezinmesi (yazarken değil)",
    "dCommandPalette": "Komut paletini aç",
    "dShowOverlay": "Bu kısayol katmanını göster",
    "dToggleSidebar": "Kenar çubuğunu aç/kapat",
    "dOpenPanel": "Yan paneli aç (Oturum, Aracılar, Geçmiş, Dosyalar, Değişiklikler, Posta, Beceriler, Ofis Haritası)",
    "dDesignStudio": "Tasarım Stüdyosu yan panelini aç",
    "dWorktrees": "Worktree yan panelini aç",
    "dFocusInput": "Mesaj girişine odaklan",
    "dSessionPanel": "Oturum paneli",
    "dFleetOverlay": "Filo izleyici katmanı",
    "dAgentsOverlay": "Aracı izleyici katmanı",
    "dWorktreeMonitor": "Worktree izleyici",
    "dPlanPanel": "Plan paneli",
    "dTodosPanel": "Yapılacaklar paneli",
    "dQueuePanel": "Kuyruk paneli",
    "dProcessMonitor": "Süreç izleyici",
    "dGoalPanel": "Hedef paneli",
    "dSessionsDashboard": "Oturum panosu",
    "dOfficeMap": "Koordinatör ofis haritası",
    "dDockPicker": "Rıhtım çip seçici",
    "dOpenFleet": "Filo izleyici katmanını aç",
    "dOpenAgents": "Aracı izleyici katmanını aç",
    "dNavigateAgents": "İzleyicide aracılar arasında gezin",
    "dSelectAgent": "Odaklanan aracıyı seç",
    "dCloseOverlay": "Etkin katmanı kapat",
    "dSendMessage": "Mesaj gönder",
    "dNewline": "Yeni satır ekle",
    "dRecallPrev": "Önceki komutu geri çağır (boş girişte)",
    "dRecallNext": "Sonraki komutu geri çağır",
    "dSlashPopup": "Slash komut açılır penceresini aç",
    "dAutocomplete": "Vurgulanan komutu otomatik tamamla",
    "dDismissPopup": "Açılır pencereyi kapat / girişi temizle",
    "dSearchChat": "Mevcut sohbette ara",
    "dClearContext": "Bağlamı temizle (/clear ile aynı)",
    "dNewSession": "Yeni oturum başlat (/new ile aynı)",
    "dExportMarkdown": "Sohbeti markdown olarak dışa aktar",
    "dModelSwitcher": "Hızlı model değiştirici katmanı",
    "dCompactDensity": "Sıkışık UI yoğunluğunu aç/kapat",
    "dAbortRun": "Mevcut çalışmayı durdur (çalışırken)",
    "dFocusNext": "Sonraki mesaja odaklan (diğer ad: ↓)",
    "dFocusPrev": "Önceki mesaja odaklan (diğer ad: ↑)",
    "dJumpFirst": "İlk mesaja atla",
    "dJumpLast": "Son mesaja atla",
    "dCopyFocused": "Odaklanan mesaj metnini kopyala",
    "dClearFocused": "Odaklanan mesajı temizle"
  },
  "sddBoard": {
    "titleFallback": "Canlı SDD Panosu",
    "defaultModelTitle": "Çalışma düzeyinde varsayılan işçi modeli (görev başına geçersiz kılmalar önceliklidir)",
    "graphLabel": "Graf",
    "kanbanLabel": "Kanban",
    "retryAllTitle": "Başarısız her görevi beklemede olacak şekilde yeniden kuyruğa al",
    "retryFailed": "Başarısız olanları yeniden dene ({{count}})",
    "resume": "Sürdür",
    "pause": "Duraklat",
    "stop": "Durdur",
    "cleanTitle": "Çalışmanın git worktree'lerini + wstack/ap dallarını kaldır",
    "cleanWorktrees": "Worktree'leri temizle",
    "rollbackTitle": "{{base}} üzerinde {{count}} birleştirilmiş commit'i geri al",
    "rollback": "Geri al ({{count}})",
    "stopping": "Durduruluyor…",
    "destroying": "Yok ediliyor…",
    "destroyTitle": "Durdur, tüm worktree'leri kaldır, isteğe bağlı olarak birleştirilmiş commit'leri geri al ve SDD projesini sil",
    "destroy": "Yok et",
    "statDone": "tamamlanan",
    "statRunning": "çalışan",
    "statFailed": "başarısız",
    "statWave": "dalga",
    "statElapsed": "geçen",
    "noActiveWorkers": "etkin işçi yok",
    "deadlock": "Kilitlenme — görevler başarısız iş tarafından engellendi:",
    "noRunTitle": "Etkin SDD çalışması yok.",
    "noRunBody": "Yeni SDD Projesi sihirbazından bir tane başlatın veya CLI'da /sdd execute ile — aracılar burada canlı görünür, her biri yalıtılmış bir worktree'de çalışır.",
    "clickTaskHint": "detaylar için bir göreve tıklayın",
    "lcClean": "Temizle",
    "lcRollback": "Geri al",
    "lcDestroy": "Yok et",
    "lcFailed": "{{op}} başarısız: {{reason}}",
    "lcUnknownError": "bilinmeyen hata",
    "lcWorktrees_one": "{{count}} worktree kaldırıldı",
    "lcWorktrees_other": "{{count}} worktree kaldırıldı",
    "lcCommits_one": "{{count}} commit geri alındı",
    "lcCommits_other": "{{count}} commit geri alındı",
    "lcDeleted": "silindi {{items}}",
    "lcNothing": "yapacak bir şey yok",
    "lcNote": "{{op}}: {{body}} — not: {{reason}}",
    "lcOk": "{{op}}: {{body}}"
  },
  "sddTask": {
    "backTitle": "Etkinliğe dön",
    "workingOn": "bu görev üzerinde çalışıyor",
    "assigned": "atanmış",
    "metaPriority": "Öncelik",
    "metaType": "Tür",
    "metaDuration": "Süre",
    "metaElapsed": "Geçen",
    "metaRetries": "Yeniden deneme",
    "metaWorktree": "Worktree",
    "workerModel": "İşçi modeli",
    "runDefault": "çalışma varsayılanı: {{model}}",
    "runDefaultPlaceholder": "Çalıştırma varsayılanı",
    "runDefaultPlaceholderModel": "Çalıştırma varsayılanı ({{model}})",
    "verificationCmd": "Doğrulama komutu",
    "gatesCompletion": "tamamlamayı geçitler (exit 0)",
    "verifyPlaceholder": "örn. pnpm vitest run path/to/file",
    "addVerify": "+ Doğrulama komutu ekle",
    "description": "Açıklama",
    "timeline": "Zaman çizelgesi",
    "dependsOn": "Bağımlı olduğu",
    "blocks": "Engellediği",
    "newWorkerPlaceholder": "Yeni işçi adı…",
    "confirmStop": "Bu çalışan görev durdurulsun mu?",
    "confirmDelete": "Bu görev çalışmadan silinsin mi?",
    "retryTitle": "Bu görevi beklemeye yeniden kuyruğa al",
    "reassign": "Yeniden ata",
    "stopTitle": "Bu görevdeki işçiyi iptal et",
    "splitTitle": "Bu görevi ayrı işçilere devredilen alt görevlere böl",
    "split": "Böl",
    "splitHint": "Satır başına bir alt görev — Başlık :: açıklama (açıklama isteğe bağlı)",
    "splitPlaceholder": "Veri katmanını yaz :: depoyu ekle\nArayüzü bağla",
    "splitInto": "Alt görevlere böl",
    "deleteTitle": "Bu başlatılmamış görevi çalışmadan kaldır"
  },
  "sddWizard": {
    "phaseStart": "Başlat",
    "phaseInterview": "Görüşme",
    "phaseSpecReview": "Spec İncelemesi",
    "phasePlanning": "Planlama",
    "phaseTaskReview": "Görev İncelemesi",
    "phaseRunning": "Çalışıyor",
    "phaseDone": "Tamamlandı",
    "titleFallback": "Yeni SDD Projesi",
    "questionsSuffix": "{{cur}}/{{max}} soru",
    "tasksSuffix": "{{count}} görev",
    "runCfgTitle": "Çalıştırma yapılandırması — varsayılan model + yedek zinciri",
    "modelsLabel": "Modeller",
    "startRun": "Çalışmayı Başlat",
    "defaultWorkerModel": "Varsayılan işçi modeli",
    "leaderDefaultPlaceholder": "Lider / oturum varsayılanı",
    "useSessionDefault": "Oturum varsayılanını kullan",
    "fallbackChain": "Yedek zinciri",
    "appliesToAll": "Her göreve uygulanır. Çalışma başladıktan sonra canlı panodan görev başına geçersiz kılın.",
    "parallelAgents": "Paralel aracılar",
    "isolateWorktrees": "Git worktree'lerinde yalıt",
    "worktreeOn": "Her görev kendi worktree'sinde çalışır, tamamlandığında squash-merge edilir.",
    "worktreeOff": "Görevler doğrudan mevcut dalda çalışır (yalıtım yok).",
    "goalPrompt": "Ne inşa etmek istiyorsunuz?",
    "goalPlaceholder": "örn. Oturum yönetimiyle OAuth girişi (Google + GitHub) ekle",
    "startingInterview": "Görüşme başlatılıyor…",
    "startInterview": "Görüşmeyi Başlat",
    "introBody": "Yalıtılmış bir aracı, bir spec oluşturmak için sizinle görüşme yapar, bunu bağımlılık sıralı bir görev grafiğine ayırır, ardından gerçek bir çok aracılı filo yürütür — panoda canlı izleyin.",
    "taskGraphSummary": "Görev grafiği · {{count}} görev, bağımlılık sıralı",
    "dragToExplore": "keşfetmek için sürükle",
    "show": "göster",
    "goalLabel": "Hedef",
    "implementationPlan": "Uygulama planı",
    "approveSpec": "Spec'i onayla → uygulamayı planla",
    "approveTasks": "Görevleri onayla",
    "approvePlan": "Planı onayla",
    "answerPlaceholder": "Soruyu cevapla…",
    "changePlaceholder": "Değişiklik iste…"
  },
  "fileExplorer": {
    "emptyDir": "boş",
    "loadFailed": "Dosyalar yüklenemedi: {{error}}",
    "expandAllTitle": "Tüm dizinleri genişlet",
    "expandAll": "Tümünü genişlet",
    "collapseAllTitle": "Tüm dizinleri daralt",
    "collapse": "Daralt",
    "folders_one": "{{count}} klasör",
    "folders_other": "{{count}} klasör",
    "currentDirTitle": "Mevcut dizin: {{path}}",
    "navigateToTitle": "{{path}} konumuna git",
    "filesSuffix_one": "{{count}} dosya",
    "filesSuffix_other": "{{count}} dosya",
    "goToDir": "dizine git",
    "navigateParentTitle": "{{path}} dosyasının üst dizinine git",
    "parentDirectory": "üst dizin",
    "noFiles": "Dosya bulunamadı",
    "copyAbsPath": "Mutlak yolu kopyala",
    "copyRelPath": "Göreli yolu kopyala",
    "openInTerminal": "Terminalde aç",
    "openInFileManager": "Dosya yöneticisinde aç",
    "mentionInChat": "Sohbette bahset",
    "copyPath": "Yolu kopyala"
  },
  "codeEditor": {
    "sendSelectionAction": "Seçimi sohbete gönder",
    "noFilesOpen": "Açık dosya yok",
    "selectToEdit": "Düzenlemeye başlamak için gezginden bir dosya seçin",
    "sendSelectedTitle": "Seçili satırları sohbete gönder",
    "mentionFileTitle": "Bu dosyayı sohbette bahset",
    "sendToChat": "Sohbete gönder",
    "mentionFile": "Dosyayı bahset",
    "loadingEditor": "Düzenleyici yükleniyor…",
    "selectTab": "İçeriğini görmek için bir sekme seçin"
  },
  "analytics": {
    "loading": "Analitik yükleniyor…",
    "heading": "Analitik Panosu",
    "autoRefresh": "10 sn'de bir otomatik yenile",
    "liveSessions": "Canlı oturumlar",
    "agents": "Aracılar",
    "agentsActive": "{{count}} etkin",
    "totalEvents": "Toplam olay",
    "categoriesSub": "{{count}} kategori",
    "toolCalls": "Araç çağrıları",
    "iterationsSub": "{{count}} yineleme",
    "sessionCost": "Oturum maliyeti",
    "tokensSub": "{{input}} girdi / {{output}} çıktı",
    "sessionDuration": "Oturum süresi",
    "messagesSub": "{{count}} mesaj",
    "eventsByCategory": "Kategoriye göre olaylar",
    "noEvents": "Henüz kayıtlı olay yok.",
    "topEvents": "En çok olaylar",
    "activeSessionUsage": "Etkin oturum kullanımı",
    "provider": "Sağlayıcı",
    "model": "Model",
    "inputTokens": "Girdi tokenleri",
    "outputTokens": "Çıktı tokenleri",
    "cacheRatio": "Önbellek oranı",
    "filesRead": "Okunan dosya",
    "noSession": "Etkin oturum yok veya veri bekleniyor…",
    "healthErrors": "Sağlık & hatalar",
    "errorEvents": "Hata olayları",
    "warningEvents": "Uyarı olayları",
    "cacheHitRate": "Önbellek isabet oranı",
    "totalCategories": "Toplam kategori",
    "waitingData": "Veri bekleniyor…",
    "recentEvents": "Son olaylar",
    "noRecentEvents": "Yakın olay yok. Olay oluşturmak için arayüzle etkileşin."
  },
  "promptLib": {
    "searchPlaceholder": "Promptları ara…",
    "newPrompt": "＋ Yeni prompt",
    "all": "Tümü",
    "recent": "🕘 Son",
    "favorites": "★ Favoriler",
    "noMatch": "Eşleşen prompt yok.",
    "newPromptHeading": "Yeni prompt",
    "titlePlaceholder": "Başlık *",
    "descPlaceholder": "Tek satır açıklama",
    "categoryPlaceholder": "Kategori",
    "tagsPlaceholder": "etiketler, virgül, ile ayrılmış",
    "contentPlaceholder": "Prompt içeriği * — değişkenler için {{name}} kullanın",
    "variables": "Değişkenler",
    "addVar": "＋ değişken",
    "varNamePlaceholder": "ad",
    "varDescPlaceholder": "açıklama",
    "removeVarTitle": "Değişkeni kaldır",
    "required": "zorunlu",
    "multiline": "çok satırlı",
    "enumPlaceholder": "enum: a, b, c",
    "savePrompt": "Promptu kaydet",
    "saveFailed": "Prompt kaydedilemedi.",
    "titleContentRequired": "Başlık ve içerik zorunludur.",
    "toggleFavoriteTitle": "Favori değiştir",
    "selectOption": "— seç —",
    "fillMissing": "Doldur: {{missing}}",
    "insertIntoChat": "Sohbete ekle",
    "selectPromptHint": "Önizlemek ve eklemek için bir prompt seçin."
  },
  "skillDetail": {
    "scopeProject": "Proje",
    "scopeGlobal": "Global",
    "scopeBundled": "Paketlenmiş",
    "timeoutError": "İstek zaman aşımına uğradı. Lütfen tekrar deneyin.",
    "updateFailed": "Güncelleme başarısız",
    "saveFailed": "Kaydetme başarısız",
    "uninstallFailed": "Kaldırma başarısız",
    "noSkillSelected": "Beceri seçilmedi",
    "selectSkillHint": "Belgelerini görmek için kenar çubuğundan bir beceri seçin",
    "goToChat": "Sohbete git",
    "openSourceRepo": "Kaynak repoyu aç",
    "copySourceUrl": "Kaynak URL'sini kopyala",
    "updatedLabel": "↑ Güncellendi: {{list}}",
    "upToDateLabel": "— Güncel: {{list}}",
    "errorsLabel": "✗ {{list}}",
    "checkUpdatesTitle": "Güncellemeleri kontrol et",
    "exportTitle": "Beceriyi .md olarak dışa aktar",
    "editTitle": "Beceriyi düzenle",
    "uninstallTitle": "Beceriyi kaldır",
    "closeTitle": "Kapat ve sohbete git",
    "backTitle": "Geri git",
    "forwardTitle": "İleri git",
    "relatedFiles": "İlgili dosyalar",
    "references": "Referanslar",
    "goToSkillTitle": "{{name}} becerisine git",
    "loadingContent": "Beceri içeriği yükleniyor…",
    "editingLabel": "Düzenleniyor {{name}}",
    "editStats": "{{lines}} satır · {{words}} kelime · {{chars}} karakter",
    "charsWarningFmt": "⚠ {{used}} MB / {{limit}} MB",
    "draftSaved": "Taslak kaydedildi",
    "draftRestored": "Taslak geri yüklendi",
    "discardDraft": "Taslağı sil",
    "splitViewTitle": "Bölünmüş görünüm",
    "hidePreviewTitle": "Önizlemeyi gizle",
    "contentPlaceholder": "Beceri içeriği (markdown)...",
    "loadFailed": "Beceri içeriği yüklenemedi",
    "noContent": "Beceri içeriği yok",
    "uninstallSkillHeading": "Beceriyi kaldır",
    "uninstallConfirm": "{{name}} kaldırılsın mı?",
    "uninstallRemovePath": "Bu, beceriyi {{path}} konumundan kaldırır ve geri alınamaz.",
    "uninstallAction": "Kaldır"
  },
  "office": {
    "sessionStats": "Oturum istatistikleri",
    "clients": "İstemciler",
    "input": "Girdi",
    "output": "Çıktı",
    "cost": "Maliyet",
    "agentsSuffix": "aracı",
    "upPrefix": "{{time}} süredir",
    "webuiClient": "WebUI İstemcisi",
    "disconnected": "Bağlantı kesildi",
    "connected": "Bağlı",
    "tuiClient": "TUI İstemcisi",
    "terminal": "Terminal",
    "repl": "REPL",
    "coordinator": "KOORDİNATÖR",
    "fleetSummary": "Filo özeti",
    "toolCallsLabel": "Araç çağrıları",
    "tokensLabel": "Tokenler",
    "coordinatingFleet": "Filoyu koordine ediyor",
    "donePrefix": "✓ tamam ·",
    "failedPrefix": "✕ başarısız ·",
    "seenPrefix": "{{time}} önce görüldü",
    "availableDesk": "Müsait masa",
    "mailboxHub": "Posta Merkezi",
    "unreadSuffix_one": "{{count}} okunmamış",
    "unreadSuffix_other": "{{count}} okunmamış",
    "allClear": "Hepsi tamam",
    "total": "Toplam",
    "unreadLabel": "Okunmamış",
    "liveActivity": "Canlı etkinlik",
    "waitingActivity": "Etkinlik bekleniyor…",
    "now": "şimdi",
    "fleetHq": "WrongStack Filo Karargahı",
    "live": "CANLI",
    "legendStatus": "Durum",
    "legendActive": "Etkin",
    "legendIdle": "Boşta",
    "legendError": "Hata",
    "legendConnections": "Bağlantılar",
    "legendMail": "Posta",
    "legendTask": "Görev",
    "legendStatusConn": "Durum",
    "arrange": "Düzenle",
    "arrangeTitle": "Düğümleri kat planına geri snapping yap",
    "feed": "Akış",
    "feedTitle": "Canlı etkinlik akışını aç/kapat",
    "broadcast": "Yayınla",
    "broadcastTitle": "Bu projedeki her canlı oturuma mesaj yayınla",
    "broadcastToAll": "Tüm oturumlara yayınla",
    "broadcastPlaceholder": "Bu projedeki her canlı aracıya mesaj gönder…",
    "broadcastSendHint": "göndermek için ⌘/Ctrl+Enter",
    "openFullView": "Tam işlem görünümünü aç",
    "rowStatus": "Durum",
    "rowModel": "Model",
    "rowTool": "Araç",
    "rowIterations": "Yinelemeler",
    "rowToolCalls": "Araç çağrıları",
    "rowTokensIn": "Girdi tokenleri",
    "rowTokensOut": "Çıktı tokenleri",
    "rowTokensTotal": "Toplam token",
    "rowContext": "Bağlam",
    "rowCost": "Maliyet",
    "rowLastSeen": "Son görülme",
    "rowSurface": "Yüzey",
    "rowBranch": "Dal",
    "rowPid": "PID",
    "rowDir": "Dizin",
    "rowAgents": "Aracılar",
    "rowUptime": "Çalışma süresi",
    "rowConnections": "Bağlantılar",
    "rowTotalMessages": "Toplam mesaj",
    "rowUnread": "Okunmamış",
    "recent": "Son",
    "noSubject": "(konusuz)",
    "fullOperationStream": "Tam işlem akışı",
    "closeEsc": "Kapat (Esc)",
    "idleDesk": "Boş masa",
    "fleetHqLabel": "Filo Karargahı",
    "clientsSuffix_one": "{{count}} istemci",
    "clientsSuffix_other": "{{count}} istemci",
    "taskFallback": "görev",
    "controlLabel": "kontrol"
  },
  "skillsList": {
    "installTitle": "Beceri yükle",
    "createTitle": "Beceri oluştur",
    "exportTitle": "Tüm becerileri .zip olarak dışa aktar",
    "checkUpdatesTitle": "Güncellemeleri kontrol et (tüm beceriler)",
    "searchPlaceholder": "Beceri ara…",
    "loading": "Yükleniyor…",
    "noSkills": "Yüklü beceri yok",
    "noMatch": "Filtreyle eşleşen beceri yok",
    "noDescription": "Açıklama yok",
    "scopeForeign": "Yabancı",
    "installHeading": "Beceri Yükle",
    "installHint": "Bir GitHub depo referansı (owner/repo) veya tam URL girin.",
    "installPlaceholder": "örn. wrongstack/skill-name veya https://github.com/owner/repo",
    "installScope": "Yükleme kapsamı:",
    "installBtn": "Yükle",
    "installedMsg": "Yüklendi: {{names}}",
    "installFailed": "Yükleme başarısız",
    "createHeading": "Beceri Oluştur",
    "createHint": "Yeni beceri iskeleti. İlk satır tetikleyicidir; ek satırlar açıklamayı oluşturur.",
    "nameLabel": "Ad",
    "namePlaceholder": "örn. benim-yeni-becerim",
    "descLabel": "Açıklama / Tetikleyici",
    "descPlaceholder": "Bu beceriyi <tetikleyici durumu> olduğunda kullan.\nTetikleyiciler: kullanıcı \"anahtar kelime\", \"başka\" der.",
    "saveIn": "Kaydet:",
    "createBtn": "Beceri Oluştur",
    "createdMsg": "Oluşturuldu: {{name}}",
    "createFailed": "Oluşturma başarısız"
  },
  "timeline": {
    "noEvents": "Henüz olay yok."
  },
  "designStudio": {
    "pickHint": "Bir kit seç — ajan buna uyacak.",
    "gallery": "Galeri",
    "galleryTitle": "Canlı önizleme galerisini aç",
    "stackTitle": "Hedef yığın",
    "loading": "Kitler yükleniyor…",
    "notFound": "Tasarım kiti bulunamadı.",
    "bestFor": "En uygun:",
    "light": "Açık",
    "dark": "Koyu"
  },
  "worktrees": {
    "detached": "(ayrık)",
    "count_one": "{{count}} worktree",
    "count_other": "{{count}} worktree",
    "baseSuffix": " · taban {{base}}",
    "baseLabel": "taban",
    "cleanOrphans": "Yetim olanları temizle",
    "cleanOrphansTitle": "Tüm yetim worktree'leri kaldır",
    "liveBusyTitle": "Bir çalışma canlı — önce durdurun",
    "rescanTitle": "Yeniden tara",
    "removed_one": "{{count}} worktree kaldırıldı.",
    "removed_other": "{{count}} worktree kaldırıldı.",
    "failed": "Başarısız",
    "mergedIntoBase": "{{branch}} tabana birleştirildi.",
    "conflictMerge": "{{branch}} birleştirilirken çakışma: {{files}}",
    "seeGit": "git'e bakın",
    "mergeFailed": "Birleştirme başarısız: {{reason}}",
    "unknownReason": "bilinmiyor",
    "mergeConfirmTitle": "{{branch}}, {{base}} ile birleştirilsin mi?",
    "mergeConfirmMsg": "Bu dalı taban dala squash-birleştirir. Çakışırsa temizce iptal eder.",
    "mergeAction": "Birleştir",
    "removeConfirmTitle": "{{branch}} kaldırılsın mı?",
    "removeConfirmMsg": "Worktree checkout'u zorla kaldırır ve dalını siler. Birleştirilmemiş iş kaybolur.",
    "empty": "Worktree yok.",
    "emptyHint": "SDD / AutoPhase çalışmaları burada izole worktree'ler oluşturur. Çöken çalışmalardan yetimler de görünür.",
    "actOpenTerm": "Terminalde aç",
    "actOpenFolder": "Klasörü aç",
    "actViewChanges": "Değişiklikleri gör",
    "actMerge": "Tabana birleştir",
    "actRemove": "Kaldır / at",
    "live": "canlı",
    "noUncommitted": "İşlenmemiş değişiklik yok",
    "commitsAhead_one": "{{count}} commit önde",
    "commitsAhead_other": "{{count}} commit önde",
    "more": "…{{count}} daha"
  },
  "officeSettings": {
    "heading": "Ofis Haritası",
    "headingHint": "Filoğunuzu canlı ajan durumuyla bir ofis kat planı olarak görselleştirin.",
    "statAgents": "Ajanlar",
    "statMail": "Posta",
    "unreadSuffix": " okunmamış",
    "sectionView": "Görünüm",
    "sectionDisplay": "Görüntü",
    "sectionBackground": "Arka plan",
    "sectionRecent": "Son Etkinlik",
    "eventsTrackedSuffix": " olay izlendi",
    "recentHint": "Posta gönderimleri, ajan oluşumları ve durum değişiklikleri burada görünür.",
    "sectionShortcuts": "Kısayollar",
    "sectionLegend": "Açıklama",
    "hudLabel": "HUD",
    "hudDesc": "Gerçek zamanlı oturum istatistik katmanını göster",
    "hudToggle": "HUD'u aç/kapat",
    "minimapLabel": "Mini harita",
    "minimapDesc": "Genel mini haritayı göster",
    "minimapToggle": "Mini haritayı aç/kapat",
    "controlsLabel": "Kontroller",
    "controlsDesc": "Yakınlaştırma ve sığdırma kontrollerini göster",
    "controlsToggle": "Kontrolleri aç/kapat",
    "animateLabel": "Kenarları canlandır",
    "animateDesc": "Aktif bağlantılarda akışı canlandır",
    "animateToggle": "Kenar animasyonunu aç/kapat",
    "legendLabel": "Açıklamayı göster",
    "legendDesc": "Durum ve bağlantı açıklamasını görüntüle",
    "legendToggle": "Açıklamayı aç/kapat",
    "feedLabel": "Canlı akış",
    "feedDesc": "En son çapraz süreç etkinliklerinin alt şeridi",
    "feedToggle": "Canlı akışı aç/kapat",
    "fitView": "Sığdır",
    "zoomIn": "Yakınlaştır",
    "zoomOut": "Uzaklaştır",
    "resetZoom": "Yakınlaştırmayı sıfırla",
    "legendActive": "Aktif (çalışıyor)",
    "legendIdle": "Boşta",
    "legendError": "Hata",
    "legendOffline": "Çevrimdışı",
    "bg": {
      "dots": "Noktalar",
      "lines": "Çizgiler",
      "cross": "Çapraz",
      "none": "Yok"
    }
  }
}
